// SETTINGS V2 atom — SToggle. ARIA switch on a native <button> — @radix-ui/
// react-switch is NOT installed and must not be added (§1/§8). Port of
// settings-kit.jsx SToggle (lines 91-103), made interactive + accessible.
import React from "react";

export interface SToggleProps {
  on: boolean;
  onToggle: (next: boolean) => void;
  disabled?: boolean;
  ariaLabel: string;
  // ADDITIVE (SETTINGS_V2_SP5 §3): when set, replaces the ON-state background
  // var(--mod-accent) with the given value (a category-identity accent hex).
  // Default undefined → every existing consumer renders byte-identical.
  color?: string;
}

const SToggle: React.FC<SToggleProps> = ({
  on,
  onToggle,
  disabled,
  ariaLabel,
  color,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => onToggle(!on)}
    style={{
      width: 34,
      height: 20,
      borderRadius: 999,
      flexShrink: 0,
      position: "relative",
      display: "inline-block",
      padding: 0,
      border: 0,
      background: disabled
        ? "var(--border-soft)"
        : on
        ? color ?? "var(--mod-accent)"
        : "var(--border)",
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? "default" : "pointer",
      transition: "background .15s",
    }}
  >
    <span
      style={{
        position: "absolute",
        top: 2,
        left: on && !disabled ? 16 : 2,
        width: 16,
        height: 16,
        borderRadius: 999,
        background: "#fff",
        boxShadow: "0 1px 2px rgba(15,23,30,0.25)",
        transition: "left .15s",
      }}
    />
  </button>
);

export default SToggle;
